<input #inputEl [(ngModel)]="selected" class="form-check-input m-0" type="checkbox">
